/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import s from './styles.scss';
import { withAnalytics } from 'edrolo/analytics';

@withAnalytics
class SelfRating extends Component {
  handleClick = (rating) => {
    const {
      onClick,
      analytics: { track },
    } = this.props;

    track('submitted lesson self rating');
    onClick(rating);
  };

  render() {
    const ratings = [1, 2, 3, 4, 5].map(function (rating) {
      return (
        <li key={rating}>
          <a
            id={`self-rating-link-${rating}`}
            onClick={() => this.handleClick(rating)}
          >
            <span>{rating}</span>
          </a>
        </li>
      );
    }, this);

    return (
      <ul className={s.selfRating} data-test="self-rating">
        {ratings}
      </ul>
    );
  }
}

export default SelfRating;
